import { GQL } from '../graphQl'
import config from '@/config'

export const CreateFactoryMutation = () => GQL`mutation CreateFactory($data: core_projects_insert_input!) {
  insert_core_projects_one(object: $data) {
    id
  }
}`

export const GetCurrentFactoryQuery = () => GQL`query GetCurrentFactory ($id: uuid!){
  core_projects (where: {id: {_eq: $id}}) {
    name
    address
    id
    active
    description
    project_user_associations (where: {status: {_neq: ${config.USER_STATUS_MAP.DELETED}}}) {
      user_id
      role_id
      system_added
      associated_user{
        id
        first_name
        email
        phone
        last_name
      }
    }
  }
}`

export const UpdateBinStatusQuery = () => GQL`mutation MyMutation($id: uuid!, $status: Boolean) {
  update_factory_storage_bins_by_pk(pk_columns: {id: $id}, _set: {is_full: $status}) {
    is_full
  }
}`

export const GetAllFactoriesQuery = () => GQL`query GetAllFactories($conditions: core_projects_bool_exp, $orderBy: [core_projects_order_by!]) {
  core_projects(where: $conditions, order_by: $orderBy) {
    name
    address
    id
    active
    description
    deleted
    description
    project_user_associations (where: {status: {_neq: ${config.USER_STATUS_MAP.DELETED}}}) {
      user_id
      role_id
      system_added
      associated_user{
        id
        first_name
        email
        last_name
        phone
      }
    }
  }
  core_projects_aggregate (where: $conditions) {
    aggregate {
      count
    }
  }
}`

export const getFactoryStorageBinQuery = () => GQL`query GetFactoryStorageBins {
  factory_storage_bins {
    id
    name
    is_full
  }
}`

export const createStorageBinQuery = () => GQL`mutation createFactoryStorageBins($count: Int!, $sequenceInput: [sequence_create_input!]!) {
  create_factory_storage_bins(count: $count, sequence_input: $sequenceInput) {
    message
  }
}`

export const updateFactoryMutation = () => GQL`mutation UpdateFactory($data: core_projects_set_input!, $id: uuid!) {
  update_core_projects_by_pk(_set: $data, pk_columns: {id: $id}) {
    id
  }
}`

export const AddSupervisorToFactoryMutation = () => GQL`
mutation AddSupervisorsToFactoryMutation($factoryUsers: [project_user_association_insert_input!]!) {
  insert_project_user_association(objects: $factoryUsers, on_conflict: {constraint: project_user_association_pkey, update_columns: [ role_id, status ], where: {status: {_neq: 1}}}) {
    affected_rows
  }
}`

export const AddUserToFactoryMutation = () => GQL`
mutation AddUserToFactoryMutation($userId: uuid!, $roleId: Int!) {
  insert_project_user_association_one(object: { user_id: $userId, role_id: $roleId }, on_conflict: {constraint: project_user_association_pkey, update_columns: [ role_id, status ], where: {status: {_neq: 1}}}) {
    user_id
      role_id
      associated_user{
        id
        first_name
        email
        last_name
        phone
      }
  }
}`

export const RemoveUserFromFactoryMutation = () => GQL`mutation RemoveUsersFromFactoryMutation($conditions: project_user_association_bool_exp!) {
  update_project_user_association(where: $conditions, _set: {status: 3}) {
    affected_rows
  }
}`

export const ChangeUserRoleMutation = () => GQL`mutation changeUserRoleMutation($userId: uuid!, $roleId: Int!) {
  update_project_user_association(where: {user_id : {_eq: $userId}}, _set: {role_id: $roleId}) {
    affected_rows
  }
}`

export const GetResourceTypesQuery = () => GQL`query GetResourceTypes {
  custom_list_values(where: {custom_list: {name: {_eq: "RESOURCE_TYPES"}, system_generated: {_eq: true}, tenant_id: {_is_null: true}}}) {
    id
    name
  }
}`

export const GetResourcesFromResourceMasterQuery = () => GQL`query GetResourceByType($type:Int!){
  core_material_master(where:{type:{_eq:2} resource_type:{_eq:$type}}){
    id
    name: material_name
  }
}`

export const addVendorToFactory = () => GQL`mutation addFactoryCollab($defaultCollab: [factory_company_association_insert_input!]!) {
  insert_factory_company_association(objects: $defaultCollab) {
    affected_rows
  }
}`

export const GetLinkedVendors = () => GQL`query GetLinkedVendorsQuery($factory_id: uuid!) {
  factory_company_association(where: {factory_id: {_eq: $factory_id}}) {
    tenant_company_association {
      target_tenant {
        id
        company_name
        company_email
        industry_vertical_value{
          name
        }
      }
    }
  }
}`

export const GetSkillsRequiredQuery = () => GQL`query GetSkillsRequired{
  custom_list_values(where:{custom_list:{name:{_eq:"Skills Required"}}}){
    id
    name
  }
}`

export const CreateResourceinstanceMutation = () => GQL`mutation CreateFactoryResources($input: factory_resource_create_input!) {
  create_factory_resource(input: $input) {
    message
  }
}`

export const GetAllResourcesQuery = () => GQL`query GetFactoryResources {
  factory_resource_association {
    name
    id
    sequence_value
    core_material_master {
      material_name
      resource_type_value {
          id
          name
      }
    }
    created_by
    created_on
    resource_state_custom_list_value {
      id
      name
    }
    resource_skills_associations {
      skill_custom_list_value {
        name
        id
      }
    }
    maintenance_window
    maintenance_window_type
    maintenance_due_date
  }
}
`

export const factoryResourceAssociationQuery = () => GQL`query factoryResourceAssociation($factoryId: uuid!, $resourceIds: [uuid!], $state: [String!]) {
  factory_resource_association(where: {factory_id: {_eq: $factoryId}, resource_id: {_in: $resourceIds}, resource_state_custom_list_value: {name: {_in: $state}}}) {
    id
    name
    resource_id
    factory_id
  }
}`

export const GetInventoryDataQuery =
  () => GQL`query GetInventoryDataQuery($jump: Int, $perPage: Int, $conditions: core_material_master_bool_exp, $orderBy: [factory_material_association_order_by!]) {
  factory_material_association(
    where: {core_material_master: $conditions}
    limit: $perPage
    offset: $jump
    order_by: $orderBy
  ) {
    core_material_master {
      workflow_template {
        name
        id
      }
      setup_time
      setup_time_duration_type
      resource_type_value {
        id
        name
      }
      type
      custom_material_id
      erp_material_id
      id
      material_type_value {
        id
        name
      }
      gross_weight
      inventory
      lead_time
      # material_storage_location {
      #   name
      # }
      material_description
      material_group
      material_group_details {
        name
        id
      }
      material_name
      material_type
      plm_material_id
      plm_record_id
      inventory
      effective_date
      status
      sequence_id
      storage_loc
      unit_cost
      unit_of_material
      material_unit_details {
        name
        id
      }
      unit_sale_price
      weight_unit
      material_weight_details {
        name
        id
      }
      product_code
      # material_product_code {
      #   id
      #   sequence_id
      #   product_code
      # }
      # tag_materials {
      #   tag {
      #     name
      #     id
      #     parent_id
      #   }
      # }
      # material_source {
      #   id
      #   source
      # }
      blob_reference_key
      # material_status {
      #   id
      #   status
      # }
    }
  }
  factory_material_association_aggregate (where: {core_material_master: $conditions}) {
    aggregate {
      count(columns: id)
    }
  }
}

`

export const UpdateFactoryResourcesQuery = () => GQL`mutation updateFactoryResource($id:uuid!, $updateObj:factory_resource_association_set_input!){
  update_factory_resource_association_by_pk(pk_columns:{id:$id},_set:$updateObj ){
    id
  }
}`
